import styled from 'styled-components';

export const InsightsRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 36px;
`;

export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  @media (max-width: 899px) {
    justify-content: space-between;
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: min-content;
  @media (max-width: 899px) {
    flex-wrap: wrap;
  }
`;

export const FilterLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0%;
  color: #b3b9c2;
  white-space: nowrap;
`;

export const Dropdown = styled.div`
  position: relative;
`;

export const DropdownTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 130px;
  border: 1px solid #d9d9d9;
  background: #fff;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0%;
  color: #2f3d48;
  white-space: nowrap;
  cursor: pointer;

  img {
    width: 10px;
    height: 10px;
    display: block;
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 100%;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 5px 10px 0 #00000033;
  padding: 6px;
  z-index: 10;
`;

export const DropdownMenuItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  text-align: left;
  border: none;
  background: transparent;
  padding: 8px 10px;
  font-size: 14px;
  font-weight: 500;
  color: #2f3d48;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #f3f4f6;
  }

  &.isActive {
    font-weight: 700;
  }
`;

export const InsightsCard = styled.div`
  background: #fff;
  border-radius: 10px;
  border: 1.5px solid #e9ebf0;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.04);
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CardTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  color: #2f3d48;
`;

export const CardSubtitle = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0%;
  line-height: 150%;
  color: #b3b9c2;
`;

export const PerformanceMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin-top: 16px;

  @media (max-width: 899px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 399px) {
    grid-template-columns: 1fr;
  }
`;

export const MetricItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-right: 1px solid #e9ebf0;

  &:last-child {
    border-right: none;
  }

  @media (max-width: 899px) {
    &:nth-child(2n) {
      border-right: none;
    }

    &:last-child {
      border-right: 1px solid #e9ebf0;
    }
  }

  @media (max-width: 399px) {
    border-right: none;
  }
`;

export const MetricValue = styled.div`
  font-size: 34px;
  font-weight: 275;
  color: #2f3d48;
  line-height: 150%;
`;

export const MetricLabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const MetricLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0%;
  color: #b3b9c2;
`;

export const TwoColumn = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 899px) {
    grid-template-columns: 1fr;
  }
`;

export const SatisfactionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
`;

export const RatingBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 26px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0;
  color: #2f3d48;

  img {
    width: 20px;
    height: 20px;
  }
`;

export const BarChart = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  padding-top: 16px;
`;

export const StarBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const StarBarPercent = styled.span`
  font-size: 13px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0%;
  color: #2f3d48;
`;

export const StarBarCount = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0%;
  color: #b3b9c2;
`;

export const StarBarTrack = styled.div`
  width: 100%;
  height: 140px;
  background: #f2f3f5;
  border-radius: 4px;
  position: relative;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
`;

export const StarBarFill = styled.div`
  width: 100%;
  background: #17c981;
`;

export const StarBarLabel = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0%;
  color: #2f3d48;
`;

export const AnswersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 16px;
`;

export const AnswerRow = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  align-items: center;
`;

export const AnswerContentRow = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 5px;
`;

export const AnswerDot = styled.span`
  display: inline-block;
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f2f3f5;

  &.isGreen {
    background: #17c981;
  }

  &.isRed {
    background: #ff2d38;
  }
`;

export const AnswerText = styled.span`
  font-size: 13px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0%;
  color: #2f3d48;
`;

export const AnswerCount = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0%;
  color: #2f3d48;
  min-width: 40px;
  text-align: end;
`;

export const AnswerBarTrack = styled.div`
  width: 100%;
  height: 6px;
  background: #f2f3f5;
  border-radius: 3px;
  overflow: hidden;
`;

export const AnswerBarFill = styled.div`
  height: 100%;
  border-radius: 3px;

  &.isGreen {
    background: #17c981;
  }

  &.isRed {
    background: #ff2d38;
  }
`;

export const Legend = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 27.5px;
  padding-top: 12px;
  border-top: 1px solid #e9ebf0;
`;

export const LegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0%;
  color: #b3b9c2;
`;

export const LegendDot = styled.span`
  display: inline-block;
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;

  &.isGreen {
    background: #17c981;
  }

  &.isRed {
    background: #ff2d38;
  }
`;

export const EmptyMessage = styled.div`
  padding: 32px 0;
  text-align: center;
  font-size: 14px;
  color: #b3b9c2;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 -12px;
  font-size: 20px;
  font-weight: 700;
  line-height: 150%;
  color: #2f3d48;
`;

export const RatingCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
`;

export const RatingCardTotal = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  color: #2f3d48;
  white-space: nowrap;
`;

export const RatingList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 16px;
`;

export const RatingItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const RatingItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const RatingItemText = styled.span`
  font-size: 13px;
  font-weight: 700;
  line-height: 150%;
  color: #2f3d48;
`;

export const RatingItemMetric = styled.span`
  font-size: 13px;
  font-weight: 400;
  line-height: 150%;
  color: #b3b9c2;
  white-space: nowrap;
`;

export const RatingBar = styled.div`
  width: 100%;
  height: 6px;
  background: #f2f3f5;
  border-radius: 3px;
  overflow: hidden;
`;

export const RatingBarFill = styled.div`
  height: 100%;
  background: #17c981;
  border-radius: 3px;
`;
